export default "__VITE_ASSET__BtvxWMvc__"